define('collections/go_order_licenses',['require','collections/base','models/go_order_license'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/go_order_license");

    return BaseCollection.extend({
        model: Model,
        url: 'go-orders.json',
        parse: function(response) {
            return response.results;
          }
    });
});
